import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// // // LIST ALL PRODUCTS BUNDLES
export const customCartList = (params = '') => Http.get(`/custom-carts${serialize(params)}`)
export const customCartByID = (params = '') => Http.get(`/custom-carts/${params}?include=networkSystem,user,items`)
export const customCartCreate = (params = '') => Http.post('/custom-carts', params)
export const customCartUpdate = (params = '') => Http.put(`/custom-carts/${params.id}`, params)
export const customCartDestroy = (params = '') => Http.delete(`/custom-carts/${params.id}`)
export const customCartListInside = (params = '') => Http.get(`/custom-carts/${params.uuid}`)
